import Vue from "vue";
import Vuex, { ModuleTree } from "vuex";
import { cloneDeep } from "lodash";
import { BootstrapConfig } from "shared/bootstrap";

Vue.use(Vuex);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const state: { [key: string]: any } = {};

let initialState: typeof state = {};

const store = new Vuex.Store({
  state,
  mutations: {
    storeInitialState(s): void {
      initialState = cloneDeep(s);
    },
    loadInitialState(s): void {
      Object.keys(initialState).forEach((key): void => {
        s[key] = initialState[key];
      });
    },
  },
});

export default store;

export const preloadStores = (config: BootstrapConfig): void => {
  store.commit("storeInitialState");
  store.commit("auth/setStateFromLocalStorage");
  store.dispatch("auth/keepLoggedInSynced");
  store.commit("global/setLoginBackground", config.loginBackground);
  store.commit("global/setBranded", config.branding);
  store.commit("global/setApplicationName", config.title);
};

export const loadModules = (modules: ModuleTree<unknown>): void => {
  const keys = Object.keys(modules);
  keys.forEach((key): void => {
    store.registerModule(key, modules[key]);
  });
};
